import * as z from "zod";

export const unsubscribeRecoverForPhoneNumber = {
  name: "unsubscribeRecoverForPhoneNumber",
  input: z.object({ teamId: z.string(), marketingConversationId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
